var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-guard',{attrs:{"route":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('base-title',{attrs:{"title":"Catalogs"}}),_c('catalog-advanced-search')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }